module.exports = __webpack_public_path__ + "img/Schnitzelparty.2371f8aa.svg";